export const areArraysDifferent = (array1: string[], array2: string[]): boolean =>
  array1.some((item) => !array2.includes(item)) || array2.some((item) => !array1.includes(item))
